import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const slides = [
    {
      image: "/main/main1.webp",
      subtitle: "Custom",
      title: "Fall Refresh",
      buttonText: "LEARN MORE",
      link: "/shop",
    },
  ];

  const feedImages = [
    { id: 1, image: "/main/main5-1.jpg", alt: "Modern Southern Style 1" },
    { id: 2, image: "/main/main5-2.jpg", alt: "Modern Southern Style 2" },
    { id: 3, image: "/main/main5-3.jpg", alt: "Bernicemy Market" },
    { id: 4, image: "/main/main5-4.jpg", alt: "Modern Southern Style 4" },
    { id: 5, image: "/main/main5-5.jpg", alt: "Modern Southern Style 5" },
    { id: 6, image: "/main/main5-6.jpg", alt: "Modern Southern Style 6" },
  ];

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const scrollFeed = (direction) => {
    const container = document.querySelector(".feed-scroll");
    if (container) {
      const scrollAmount = 370; // item width (350px) + gap (20px)
      const newScroll =
        direction === "left"
          ? container.scrollLeft - scrollAmount
          : container.scrollLeft + scrollAmount;
      container.scrollTo({
        left: newScroll,
        behavior: "smooth",
      });
    }
  };

  return (
    <body className="color-scheme color-scheme--scheme-1">
      <Header />
      <main className="main-content">
        {/* Hero Carousel Section */}
        <section className="hero-carousel">
          <div className="carousel-container">
            {slides.map((slide, index) => (
              <div key={index} className="carousel-slide active">
                <div className="slide-image">
                  <img src={slide.image} alt={slide.title} />
                </div>
                <div className="slide-content">
                  <p className="slide-subtitle">{slide.subtitle}</p>
                  <h1 className="slide-title">{slide.title}</h1>
                  <Link
                    to={slide.link}
                    className="slide-button"
                    onClick={toTop}
                  >
                    {slide.buttonText}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Featured Products Section */}
        <section className="featured-products">
          <div className="section-header">
            <h2>Featured Collections</h2>
            <p>Discover our carefully curated selections</p>
          </div>
          <div className="products-grid">
            {productData.slice(0, 4).map((product) => (
              <Link
                to={`/shopDetails/${product.id}`}
                key={product.id}
                className="product-card"
                onClick={toTop}
              >
                <div className="product-image">
                  <img src={product.images[0]} alt={product.name} />
                </div>
                <div className="product-info">
                  <h3>{product.name}</h3>
                  <p className="product-price">${product.price}</p>
                </div>
              </Link>
            ))}
          </div>
        </section>

        {/* Custom Journey Section */}
        <section className="custom-journey">
          <div className="journey-content">
            <div className="journey-text">
              <h2>Your Custom Journey Starts Here</h2>
              <p>
                We're expanding our offering with a new custom tailoring
                program, pouring two decades of experience in creating heritage,
                lasting styles into tailoring crafted to your exact
                measurements. Book an appointment with our team of expert
                stylists and create something you'll wear for years to come.
              </p>
              <Link to="/contact" className="journey-button" onClick={toTop}>
                LEARN MORE
              </Link>
            </div>
            <div className="journey-image">
              <img src="/main/main2.webp" alt="Custom Tailoring" />
            </div>
          </div>
        </section>

        {/* Designed to Live Section */}
        <section className="designed-to-live">
          <div className="designed-container">
            <h2 className="designed-title">Designed to Live. Made to Last.</h2>
            <div className="designed-content">
              <div className="designed-video">
                <video
                  src="/main/main3-1.mp4"
                  alt="Team Photo"
                  autoPlay
                  muted
                  loop
                >
                  <source src="/main/main3-1.mp4" type="video/mp4" />
                </video>
                <button className="video-play-button">PLAY VIDEO</button>
              </div>
              <div className="designed-profile">
                <div className="profile-image">
                  <img src="/main/main3-2.webp" alt="Bernicemy" />
                </div>
                <p className="profile-text">
                  From our home in Florence, Alabama, we bring our sensibility
                  to the world at large through standout clothing, crafted with
                  integrity and authenticity.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Brand Story Section */}
        <section className="brand-story">
          <div className="story-content">
            <div className="story-text">
              <h2>Heritage Meets Modern Craftsmanship</h2>
              <p>
                For over two decades, we've been dedicated to creating timeless
                pieces that blend traditional craftsmanship with contemporary
                design. Each garment tells a story of meticulous attention to
                detail and unwavering commitment to quality.
              </p>
              <Link to="/about" className="story-link" onClick={toTop}>
                Discover Our Story →
              </Link>
            </div>
          </div>
        </section>

        {/* Buy Online Pick Up Section */}
        <section className="buy-online-pickup">
          <div className="pickup-content">
            <div className="pickup-image">
              <img src="/main/main4.webp" alt="Store Interior" />
            </div>
            <div className="pickup-text">
              <h2>Buy Online, Pick Up In Store</h2>
              <p>
                Easy and just in the nick of time. Get what you need when you
                need it. Simply select your shop at checkout, wait for your
                order confirmation, and pick-up in your local shop. Depending on
                the time of day and shop hours, most orders are ready within two
                to three hours.
              </p>
              <Link to="/shop" className="pickup-button" onClick={toTop}>
                FIND A SHOP
              </Link>
            </div>
          </div>
        </section>

        {/* Shop The Feed Section */}
        <section className="shop-the-feed">
          <div className="feed-header">
            <span className="feed-hashtag">#MODERNSOUTHERN</span>
            <h2 className="feed-title">
              Shop The Feed
              <Link
                to="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="instagram-link"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"
                    fill="currentColor"
                  />
                </svg>
              </Link>
            </h2>
          </div>
          <div className="feed-gallery">
            <button
              className="feed-nav feed-nav-left"
              aria-label="Previous"
              onClick={() => scrollFeed("left")}
            >
              ‹
            </button>
            <div className="feed-scroll">
              {feedImages.map((item) => (
                <div key={item.id} className="feed-item">
                  <img src={item.image} alt={item.alt} />
                  <div className="feed-overlay">
                    <span className="feed-icon">🛍️</span>
                  </div>
                </div>
              ))}
            </div>
            <button
              className="feed-nav feed-nav-right"
              aria-label="Next"
              onClick={() => scrollFeed("right")}
            >
              ›
            </button>
          </div>
        </section>
      </main>
      <Footer />
    </body>
  );
}

export default Main;
